import React from 'react';

interface TabPanelProps {
  value: number;
  children: JSX.Element | JSX.Element[];
  index: number;
  id?: string; // id can be passed as prop or generated using index
  fullHeight?: boolean; // optional prop to maintain backwards compatibility
}

export const TabPanel: React.FC<TabPanelProps> = ({
  children,
  value,
  index,
  id,
  fullHeight = false
}): JSX.Element => {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={id}
      aria-labelledby={`tw-tab-${id}`}
      style={{
        height: fullHeight ? '100%' : 'auto'
      }}
    >
      {value === index && <div>{children}</div>}
    </div>
  );
};
